import { render, staticRenderFns } from "./relatedShop.vue?vue&type=template&id=4495584e&scoped=true&"
import script from "./relatedShop.vue?vue&type=script&lang=js&"
export * from "./relatedShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4495584e",
  null
  
)

export default component.exports